import {type UIGameManager} from '../../UIGameManager.ts'
import {SpriteView} from '../../../ui_canvas_engine/SpriteView.ts'
import {type PIXI} from '@colonist/pixi'
import {type TranslationObject} from '@colonist/i18n'
import {GameColor} from '../../../GameColor.ts'
import {type UIGameAnimation} from '../../UIGameEventController.ts'
import {UIGameOpacityAnimation} from '../../../ui_canvas_engine/UIGameOpacityAnimation.ts'
import {Sprites} from '../../UIGameImageDictionary.ts'
import {UIGameSpriteHandler} from '../../../UIGameSpriteHandler.ts'

export class UIGameMapPortView implements UIGameAnimation {
    private readonly uiGameManager: UIGameManager
    private readonly portView: SpriteView
    private readonly highlightAnimation: UIGameOpacityAnimation
    private portHighlight?: SpriteView | undefined

    constructor(uiGameManager: UIGameManager, x: number, y: number, w: number, h: number, container: PIXI.Container, texture: PIXI.Texture) {
        this.uiGameManager = uiGameManager
        this.highlightAnimation = new UIGameOpacityAnimation()
        this.portView = new SpriteView(x, y, w, h, container, texture)
        this.portView.zIndex = this.uiGameManager.mapController.mapView.layers.ports
    }

    onGameTick(deltaTime: number, elapsedMS: number) {
        if(this.portHighlight == undefined) return
        this.highlightAnimation.animateOpacity(this.portHighlight)
    }

    setTip(title: TranslationObject, body: TranslationObject[]) {
        this.portView.setTip(title, body)
    }

    highlight() {
        this.removeHighlight()
        this.uiGameManager.eventController.registerUIGameAnimation(this)
        const portSize = this.portView.width
        const highlightX = this.portView.x + portSize * 0.16
        const highlightY = this.portView.y - portSize * 0.01
        const highlightW = portSize * 0.75
        const highlightH = portSize * 1.04

        this.portHighlight = new SpriteView(highlightX, highlightY, highlightW, highlightH, this.uiGameManager.mapController.mapView, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.port_highlight))
        this.portView.tint = GameColor.getColorHexValue(GameColor.Color.GrayScale18)
        this.portHighlight.zIndex = this.uiGameManager.mapController.mapView.layers.mapTiles
        this.uiGameManager.mapController.mapView.sortChildren()
    }

    removeHighlight() {
        if(this.portHighlight == undefined) return
        this.uiGameManager.eventController.unregisterUIGameAnimation(this)
        this.portHighlight.parent.removeChild(this.portHighlight)
        this.portHighlight.destroy()
        this.portHighlight = undefined
        this.portView.tint = GameColor.getColorHexValue(GameColor.Color.GrayScale25)
    }
}
